/* eslint-disable no-prototype-builtins */

import axios from "axios";
import { honertTrim } from "@/utils/trim.js";
import {getStorageUserRoleId} from '@/utils/store'
import { MessageBox } from 'element-ui';
import { loginOutStorage} from '@/utils/store'

class ajax {
    constructor(option, interceptorsRequest, interceptorsResponse) {
        if (typeof option === "function") {
            if (typeof interceptorsRequest === "function") {
                interceptorsResponse = interceptorsRequest;
                interceptorsRequest = option;
            } else {
                interceptorsRequest = option;
                interceptorsResponse = (response) => {
                    return response;
                };
            }
            option = {};
        }
        option = typeof option === "object" ? option : {};
        interceptorsRequest =
            typeof interceptorsRequest === "function" ?
            interceptorsRequest :
            (config) => {
                return config;
            };
        interceptorsResponse =
            typeof interceptorsResponse === "function" ?
            interceptorsResponse :
            (response) => {
                return response;
            };

        let params = Object.assign({}, {
                baseURL: "/",
                timeout: 300000, 
                // withCredentials: true,
            },
            option
        );
        this.request = null;
        this.init(params, interceptorsRequest, interceptorsResponse);
    }
    init(params, req, res) {
        console.log('init params:'+JSON.stringify(params));

        this.request = axios.create(params);
        this.request.interceptors.request.use(
            async(config) => {
                config = req(config);
                return config;
            },
            function(error) {
                // 对请求错误做些什么
                return Promise.reject(error);
            }
        );
        this.request.interceptors.response.use(
            (response) => {
                response = res(response);

                if(response&&response.Result==-10){ //账户异常时，提示用户，然后退出
                    MessageBox.alert(response.Message,'提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                            loginOutStorage();
                            window.location.href = '/#/login'; //转登录
                        }
                    });  
                }

                return response;
            },
            function(error) {
                // 对响应错误做点什么
                return Promise.reject(error);
            }
        );
    }
    post(url, data = {}) {
        // data['platform'] = 'pcweb';
        const val = data.platform;
        val ? data['platform'] = val : data['platform'] = 'pcweb';
        data['ManageUserId'] = getStorageUserRoleId();
        return this.request.request({ method: "post", url: url, data });
    }
    postForm(url, data = {}) {
        var bodyFormData = new FormData();
        for (const key in data) {
            bodyFormData.append(key, data[key]);
        }
        return this.request.request({
            method: "post",
            url: url,
            data: bodyFormData,
        });
    }
    put(url, data = {}) {
        return this.request.request({ method: "put", url: url, data });
    }
    delete(url, data = {}) {
        return this.request.request({ method: "delete", url: url, data });
    }
    get(url, data = {}) {
        let arry = [];
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                if (Array.isArray(data[key])) {
                    data[key].map((obj) => {
                        arry.push(key + "[]=" + honertTrim(obj));
                    });
                } else {
                    arry.push(key + "=" + honertTrim(data[key]));
                }
            }
        }
        return this.request.request({
            method: "get",
            url: url + "?" + arry.join("&"),
            data,
        });
    }
}

export default ajax;